import { inquiryTypeOptions } from "entities/customerTickets/constants";
import React, { FC } from "react";
import Select from "shared/components/Form/Select";
import { COLOR_BLACK } from "shared/theme/colors";
import Links from "./components/Links";
import TopContent from "./components/TopContent";
import { StyledSeparator, StyledUserDetailsContainer } from "./styled";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import AISummary from "./components/AISummary";

const TicketDetails: FC = () => {
  const { ticketStatus, handleChangeTicketStatus } = useCustomerTicketsPage();

  return (
    <StyledUserDetailsContainer>
      <TopContent />
      <StyledSeparator />
      <Links />
      <StyledSeparator />
      <Select
        id="inquiryStatus"
        label="Inquiry Status"
        labelColor={COLOR_BLACK}
        placeholder="Select a type"
        disabledPlaceholder
        fullWidth
        required
        value={ticketStatus ?? undefined}
        handleChange={(value) => handleChangeTicketStatus(value)}
        options={inquiryTypeOptions}
      />
      <StyledSeparator />
      <AISummary />
    </StyledUserDetailsContainer>
  );
};

export default TicketDetails;
